import i18n from '@/config/i18n';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyDAz8DKrMu3tvUouRVRIE-_0SXbKHUDOHM',
  authDomain: 'vcard-converter.firebaseapp.com',
  databaseURL: 'https://vcard-converter.firebaseio.com',
  projectId: 'vcard-converter',
  storageBucket: 'vcard-converter.appspot.com',
  messagingSenderId: '495858649984',
  appId: '1:495858649984:web:ff90c744b6c8cf84908f65',
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.auth().languageCode = i18n.locale;

export default firebase;
